import React from 'react';
import { TestimonialCarousselAutoSection } from 'libs/growth-platform-brand-system-v2/src/templates/TestimonialCarousselAutoSection';
import { morphism } from 'morphism';
import { schemaImage } from '../../morphismSchema/components/schemaImage';
import { TrackingVideo } from '../TrackingVideo';
import { Image } from 'libs/growth-platform-brand-system-v2/src/components/Image';

const prepareCard = (card: any) => {
  if (card?.__typename === 'DatoCmsTestimonialCardReview') {
    const { name, rating, review, origin } = card;

    return { name, rating, review, origin, type: 'rating' };
  }
  if (card?.__typename === 'DatoCmsTestimonialCardVideo') {
    const {
      image: imageCard,
      logo: logoCard,
      overlay,
      subtitle,
      title,
      video,
    } = card;
    const logoCardData = morphism(schemaImage, logoCard);
    const _logoCard = logoCard && (
      <Image {...logoCardData} pixelDensity="default" sizes="108px" />
    );
    const imageCardData = morphism(schemaImage, imageCard);
    const _imageCard = imageCard && (
      <Image
        {...imageCardData}
        pixelDensity="default"
        sizes="(min-width: 453px) 453px, 732px"
      />
    );
    const VideoPlayer = video?.url && <TrackingVideo url={video.url} />;
    return {
      image: _imageCard,
      logo: _logoCard,
      overlay,
      subtitle,
      title,
      type: 'video',
      VideoPlayer,
    };
  }
};
export const TestimonialCarousselAutoScrollingComponent = ({ block }: any) => {
  const { logo, tag, title, firstLineCards, secondLineCards } = block;
  const logoData = morphism(schemaImage, logo);
  const _logo = logo && (
    <Image {...logoData} sizes="135px" pixelDensity="default" />
  );

  const _firstLineCards = firstLineCards?.map((card: any) => {
    return prepareCard(card);
  });
  const _secondLineCards = secondLineCards?.map((card: any) => {
    return prepareCard(card);
  });

  return (
    <TestimonialCarousselAutoSection
      logo={_logo}
      tag={tag}
      title={title}
      cardsFirstLine={_firstLineCards}
      cardsSecondLine={_secondLineCards}
    />
  );
};
export default TestimonialCarousselAutoScrollingComponent;
